module.exports = __webpack_public_path__ + "img/jigou.5f626870.png";